import React, { createContext, useState } from 'react';

export const context = createContext();

export const Provider = ({ children }) => {
  const [featureAccess, setFeatureAccess] = useState();
  return <context.Provider value={{ featureAccess, setFeatureAccess }}>{children}</context.Provider>;
};
